module.exports = __webpack_public_path__ + "img/session.cfb1d06e.svg";